<template>
  <v-card class="elevation-0" style="border: 1px dotted #fff;">

    <v-layout>
      <v-flex xs1 class="">
        <v-radio-group v-model="primary" :mandatory="false" @click="setPrimary()">
          <v-radio value="primary"></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs1 class="pt-2">
        <v-list-tile-avatar>
          <img v-if="contractor.photo" :src="contractor.photo"/>
          <v-icon v-else style="color: #907fa5; font-size: 40px;">mdi-account-circle</v-icon>
        </v-list-tile-avatar>
      </v-flex>
      <v-flex xs5>
        <v-flex xs12 class="my-1" style="color: #907fa5;">{{ contractor.post }}</v-flex>
        <v-flex xs12>
          <span class="contractor-name">{{ contractor.name }}</span>
        </v-flex>
      </v-flex>
      <v-flex xs2>
        <v-text-field
                v-model="contractor.rate"
                slot="activator"
                label="Норма"
                mask="######"
                persistent-hint
        ></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
                    color="secondary"
                    dark
                    small
                    v-on="on"
                    class="mt-3"
            >
              <v-icon class="ma-0" style="color: #fff;">mdi-chevron-down</v-icon>
              {{ unit.name }}
            </v-btn>
          </template>
          <v-list>
            <v-list-tile
                    v-for="( item, index ) in unit.list"
                    :key="index"
                    @click="selectUnit( item.code, item.name )"
            >
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
      <v-flex xs1 class="pl-1">
        <v-btn v-if="close" flat fab small class="mt-2" @click="onDelete()">
          <v-icon class="mx-0" style="color: #999;">close</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

  </v-card>
</template>

<script>

  /**
   * Единицы измерения нормы.
   *
   */
  const UNITS = [
    {
      name: 'Минута',
      code: 10
    },
    {
      name: 'Час',
      code: 20
    },
    {
      name: 'День',
      code: 30
    },
    {
      name: 'Неделя',
      code: 40
    },
    {
      name: 'Месяц',
      code: 50
    }
  ]

  /**
   * Ведущий исполнитель.
   *
   */
  const ROLE_PRIMARY_EXECUTOR = 10

  /**
   * Дополнительный исполнитель.
   *
   */
  const ROLE_EXECUTOR = 1

  /**
   *
   *
   */
  export default {

    name: 'ContractorRate',

    components: {

    },

    /**
     * Входящие данные.
     *
     */
    props: {

      // Контрагент.
      contractor: {
        type: Object,
        required: false,
        default: ''
      },

      // Разрешение на удаление контрагента.
      close: {
        type: Boolean,
        required: false,
        default: true
      }
    },

    /**
     * Операционные данные.
     *
     */
    data() {

      return {

        unit: {
          name: 'Минута',
          list: UNITS
        },

        primary: 'primary'
      }
    },

    /**
     * После создания компонента.
     *
     */
    created() {
      this.init()
    },

    /**
     * Отслеживание изменений свойств компонента.
     *
     */
    watch: {

      //
      contractor: {

        handler( value ) {
          this.unit.name = this.getUnitName( value.unit )
          this.primary = value.role === ROLE_PRIMARY_EXECUTOR ? 'primary' : 'secondary'
        },

        deep: true,
        immediate: true
      }
    },

    /**
     *
     *
     */
    computed: {

    },

    /**
     * Методы.
     *
     */
    methods: {

      /**
       * Инициализация компонента.
       *
       */
      init() {

      },

      /**
       * Получение названия единицы измерения нормы.
       *
       */
      getUnitName( code ) {
        let unit = this.unit.list.find( unit => unit.code === code )
        return unit ? unit.name : null
      },

      /**
       * Получение кода единицы измерения нормы.
       *
       */
      getUnitCode( name ) {
        let unit = this.unit.list.find( unit => unit.name === name )
        return unit ? unit.code : null
      },

      /**
       * Удаление исполнителя.
       *
       */
      onDelete() {
        this.$emit( 'delete', this.contractor.post_id )
      },

      /**
       * Установка исполнителя ведущим.
       *
       */
      setPrimary() {
        this.contractor.role = ROLE_PRIMARY_EXECUTOR
        this.$emit( 'primary', this.contractor.post_id )
      },

      /**
       * Изменение единицы измерений нормы для исполнителя.
       *
       * @param code
       * @param name
       */
      selectUnit( code, name ) {
        this.unit.name = name
        this.contractor.unit = code
      }
    }
  }

</script>

<style>

  /*.company-tree-node {*/
    /*!*font-size: 12px;*!*/
  /*}*/

  /*.v-treeview-node__content, .v-treeview-node__label {*/
    /*font-size: 14px;*/
  /*}*/

  .contractor-name {
    /*text-decoration: underline;*/
    text-decoration: none;
    border-bottom: 1px dashed #666;
  }

</style>



// WEBPACK FOOTER //
// src/apps/bpm/components/ContractorRate.vue